/**
 * `core/wordpress/mwwpform/mwwpformErrorHandler.js`
 * - MW WP Form のエラー処理
 *
 * 使用方法:
 * - import {mwwpformErrorHandler} from "../wordpress/mwwpform/mwwpformErrorHandler.js";
 */


export function mwwpformErrorHandler() {
  console.log("❗ Handling MW WP Form Errors...");
  document.querySelectorAll('.mw_wp_form .error').forEach((errorElement) => {
    const parentElement = errorElement.closest('.form_list_cnt');
    if (parentElement) {
      parentElement.classList.add('is-error');
    }
  });
}